import PropTypes from 'prop-types';
import { Segmented } from 'antd';
import styled from 'styled-components';

const Wrap = styled.div`
    margin-bottom: 16px;
    width: ${({ $width }) => $width || '400px'};
    max-width: 100%;
    box-sizing: border-box;

    .ant-segmented {
        width: 100%;
    }
`;

/**
 * Compact segmented control (not full viewport width). For switching between two primary views.
 */
export function ViewModeSegmented({ value, onChange, options, size = 'large', block = true, $width, ...rest }) {
    return (
        <Wrap $width={$width}>
            <Segmented block={block} size={size} value={value} onChange={onChange} options={options} {...rest} />
        </Wrap>
    );
}

ViewModeSegmented.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.node.isRequired,
        })
    ).isRequired,
    size: PropTypes.string,
    block: PropTypes.bool,
    $width: PropTypes.string,
};
